export default __webpack_public_path__ + "static/media/Helsingin-Sanomat.28462950.svg";